import { IEmpresaResponse } from "@/features/contabil/services/shared/requests/types";
import Empresa from "./Empresa";
import { RegimeTributarioEnum } from "@/features/contabil/@types/types";
import CNPJ from "./CNPJ";
import { ITiposDiagnostico } from "@/features/contabil/services/shared/gateways/Diagnostico";

export default class EmpresaMapper {
  static toEntity(
    empresaResponse: IEmpresaResponse,
    diagnosticos?: Partial<ITiposDiagnostico>
  ): Empresa {
    return Empresa.create({
      id: empresaResponse.id,
      nomeFantasia: empresaResponse.nomeFantasia || "-",
      razaoSocial: empresaResponse.razaoSocial || "-",
      regimeTributario:
        empresaResponse.regimeTributario || RegimeTributarioEnum.None,
      podeVisualizarVisaoEstrategica:
        empresaResponse.podeVisualizarVisaoEstrategica || false,
      cnpj: CNPJ.create({
        completo: empresaResponse.cnpj.completo,
        filial: empresaResponse.cnpj.filial,
        raiz: empresaResponse.cnpj.raiz
      }),
      updatedAt: empresaResponse.updatedAt || "-",
      diagnosticos: diagnosticos
    });
  }
}
